import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../Constants";
import { useAuth } from "../../contexts/AuthContext";
import { ColorRing } from 'react-loader-spinner';
import { KeyboardArrowUp } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

const Profile = () => {
    const userImg = '/assets/navbar/base.svg'
    const [selected, setSelected] = useState('Basic');

    const [welcomeVisible, setWelcomeVisible] = useState(true);
    const [newFile, setNewFile] = useState(userImg);
    const [newFileName, setNewFileName] = useState(null);
    const [contentVisible, setContentVisible] = useState(false);
    const [basicFormData, setBasicFormData] = useState({
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        state: '',
        address: '',
        phone: '',
        city: '',
        zip: '',
        profilePictureUrl: '',
        rowsPerPage: 25,
    });
    const [companyFormData, setCompanyFormData] = useState({

        position: '',
        startDate: '',
        endDate: '',
    });

    const { user, setUser } = useAuth();
    const [displayPic, setDisplayPic] = useState(user?.profilePictureUrl);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setDisplayPic(user?.profilePictureUrl);
        }
    }, [user]);



    // Transition Effect Timers
    useEffect(() => {
        if (user) {
            setWelcomeVisible(true);
            setTimeout(() => {
                setWelcomeVisible(false);
            }, 750);
        }
    }, [user]);

    useEffect(() => {
        if (!welcomeVisible && user) {
            setTimeout(() => {
                setContentVisible(true);
            }, 750);
        }
    }, [welcomeVisible, user]);

    useEffect(() => {

        populateFormData(user);
    }, [user]);


    const populateFormData = (data) => {
        setBasicFormData((prevData) => ({
            ...prevData,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            username: data.username || '',
            email: data.email || '',
            state: data.state || '',
            address: data.address || '',
            phone: data.phone || '',
            city: data.city || '',
            zip: data.zip || '',
            profilePictureUrl: data?.profilePictureUrl || `https://siteserviceprofileblobs.blob.core.windows.net/profileimages/baseUser.png`,
            rowsPerPage: data.rowsPerPage || 25,
        }));

        setCompanyFormData((prevData) => ({
            ...prevData,

            position: data.position || '',
            startDate: data.startDate || '',
            endDate: data.endDate || '',
            sessionTime: data.sessionTime || ''
        }));
    };

    //Used for populating either basic or company fields
    const basicFields = [
        { label: 'First Name', name: 'firstName', type: 'text', required: true },
        { label: 'Last Name', name: 'lastName', type: 'text', required: true },
        { label: 'Username', name: 'username', type: 'text', required: true },
        { label: 'Email', name: 'email', type: 'email', required: true },
        { label: 'State', name: 'state', type: 'text', required: true },
        { label: 'Address', name: 'address', type: 'text', required: false },
        { label: 'Phone', name: 'phone', type: 'text', required: false },
        { label: 'City', name: 'city', type: 'text', required: false },
        { label: 'Zip', name: 'zip', type: 'text', required: false },
        { label: 'Default Rows Per Page', name: 'rowsPerPage', type: 'select' },
    ];
    const companyFields = [
        // { label: 'Role', name: 'role', type: 'text', required: true },
        { label: 'Position', name: 'position', type: 'text', required: true },
        { label: 'Start Date', name: 'startDate', type: 'date', required: false },
        { label: 'End Date', name: 'endDate', type: 'date', required: false },
    ];


    const handleToggle = (target) => {
        if (selected === target.innerText) {
            return;
        }
        setSelected(target.innerText);
    };


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {

            // Validate file extension
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!allowedExtensions.includes(fileExtension)) {
                alert('Please select a valid image file (jpg, jpeg, png, or gif)');
                return;

            }

            // Validate file size (5MB limit)
            if (file.size > 50 * 1024 * 1024) {
                alert('File size should be less than 50MB');
                return;
            }




            // Derive file extension

            const timestamp = new Date().getTime();
            const name = `profile${user.id}-${timestamp}.${fileExtension}`;


            // Preview the image using FileReader
            const reader = new FileReader();


            reader.onload = (e) => {
                setNewFile(e.target.result); // Base64 preview
                setBasicFormData((prevData) => ({
                    ...prevData,
                    profilePictureUrl: `https://siteserviceprofileblobs.blob.core.windows.net/profileimages/${name}`,
                }));
            };

            reader.onloadend = () => {
                setDisplayPic(reader.result);
            }


            reader.readAsDataURL(file);

            // Update file state for upload
            const renamedFile = new File([file], name, { type: file.type });
            setNewFileName(renamedFile);
        }
    };

    const handleBasicChange = (e) => {
        const { name, value } = e.target;
        setBasicFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleCompanyChange = (e) => {
        const { name, value } = e.target;
        setCompanyFormData((prevData) => ({ ...prevData, [name]: value }));
    };


    const handleCancelImg = () => {
        setNewFile(user?.profilePictureUrl);
        setBasicFormData((prevData) => ({
            ...prevData,
            profilePictureUrl: user?.profilePictureUrl,
        }));
        setDisplayPic(user?.profilePictureUrl);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        //New image file must be sent as FormData
        const formData = new FormData();
        formData.append("file", newFileName);
        const updateData = { ...basicFormData, ...companyFormData };


        try {
            //Update all text fields
            const response = await fetch(`${API_BASE_URL}/api/admin/users/${user.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(updateData),
            });


            var blobData = user?.profilePictureUrl;
            if (displayPic !== user?.profilePictureUrl) {
                var oldBlob = user?.profilePictureUrl.split('/')[4];
                const changeBlob = await fetch(`${API_BASE_URL}/api/blob/updatePhoto?oldBlob=${encodeURIComponent(oldBlob)}`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        // "Content-Type": "multipart/form-data",
                    },
                    credentials: 'include'
                });

                if (!changeBlob.ok) {
                    throw new Error('Error updating profile picture');

                }
                blobData = await changeBlob.text();
            }

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('user', JSON.stringify({ ...data, profilePictureUrl: blobData }));
                setUser({ ...data, profilePictureUrl: blobData });
                alert('Profile updated successfully');
            }

        } catch (error) {
            console.error('Error editing profile:', error);
            alert('An error occurred while editing profile');
        } finally {
            setIsLoading(false);
        }
    };


    return (

        <div className="w-full h-screen flex overflow-x-hidden">


            {/* Greeting */}
            {user && newFile === userImg && <div className={`absolute w-full flex pt-40 justify-center transform transition-opacity duration-1000 ${welcomeVisible ? 'opacity-100' : 'opacity-0'} pointer-events-none`}>
                <h1 className="text-4xl">Welcome Back, {user.firstName}!</h1>
            </div>}

            {/*Profile Image Div*/}
            <div className={`h-2/3 w-1/2 pl-40 items-center gap-10 flex flex-col justify-center transform transition-transform duration-700 ${contentVisible ? 'translate-x-0' : '-translate-x-full'}`} >
                <img
                    // src={newFile === '/assets/navbar/base.svg' ? user.profilePictureUrl : '/assets/navbar/base.svg'}
                    src={displayPic || '/assets/navbar/base.svg'}
                    alt="User Avatar"
                    className="w-[250px] h-[250px] border-2 rounded-full border-gray-200"
                    onError={(e) => {
                        e.target.src = '/assets/navbar/base.svg';
                    }}
                />


                {!isLoading && <div className="flex flex-row w-1/2 justify-center items-center" >
                    <label htmlFor="imgLoad" className="flex flex-col w-1/2 mx-2 px-2 justify-center items-center py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 text-center">
                        <span>   Upload </span><KeyboardArrowUp />

                    </label>
                    <input id="imgLoad" type="file" className="hidden" onChange={handleFileChange} />
                    {/* cancel button*/}

                    {displayPic !== user?.profilePictureUrl && <label htmlFor="cancel" className="flex flex-col justify-center items-center w-1/2 mx-2 px-2 py-2  bg-red-500 text-white font-semibold rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 text-center">
                        <span>   Cancel </span> <CloseIcon />
                        <button id="cancel" className="hidden" onClick={handleCancelImg}></button>
                    </label>}

                </div>}



            </div>

            {/* Data container div */}

            <div className={`h-2/3 w-1/2  flex flex-col rounded-lg transform transition-transform duration-700 ${contentVisible ? '-translate-x-0' : 'translate-x-full'}`}>
                {/* {!isLoading ? <>*/}




                <div className="w-2/3 border-2 h-full flex flex-col rounded-lg justify-center">
                    {isLoading ?
                        (<div className="flex justify-center items-center">
                            <ColorRing
                                visible={isLoading}
                                height="100"
                                width="100"
                                ariaLabel="color-ring-loading"
                                wrapperStyle={{}}
                                wrapperClass="color-ring-wrapper"
                                colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
                            />
                        </div>)
                        :
                        (<>
                            <div className="border-b-2 w-full h-fit p-2 justify-evenly flex">
                                <label className="bg-gray-100 relative cursor-pointer w-2/3 h-10 rounded-full flex items-center">
                                    <div className={`rounded-full h-full w-1/2 transition-all ${selected === 'Basic' ? 'translate-x-0 bg-blue-500' : 'translate-x-full bg-green-500'}`}
                                    ></div>
                                    <input type="checkbox" id="check" className="sr-only" checked={selected === 'Company'} readOnly />
                                    <button className={`absolute left-0 px-4 w-1/2 text-center ${selected === 'Basic' ? 'text-white' : 'text-gray-600'}`} onClick={(e) => handleToggle(e.target)}>Basic</button>
                                    <button className={`absolute right-0 px-4 w-1/2 text-center ${selected === 'Company' ? 'text-white' : 'text-gray-600'}`} onClick={(e) => handleToggle(e.target)}>Company</button>
                                </label>
                            </div>

                            <div className="overflow-auto flex mb-4 px-4 w-full">
                                {selected === 'Basic' ? (
                                    <form action="" onSubmit={handleSubmit} className="w-full">
                                        <div className="grid grid-cols-1 gap-2 w-full">
                                            {basicFields.map((field) => (
                                                <div key={field.name}>
                                                    <label className="block text-black">{field.label}:</label>
                                                    {field.type === 'select' ? (
                                                        <select
                                                            name={field.name}
                                                            value={basicFormData[field.name]}
                                                            onChange={handleBasicChange}
                                                            className="w-full px-3 py-2 border rounded-md"
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    ) : (
                                                        <input
                                                            type={field.type}
                                                            name={field.name}
                                                            value={basicFormData[field.name]}
                                                            onChange={handleBasicChange}
                                                            required={field.required}
                                                            className="w-full px-3 py-2 border rounded-md"
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </form>
                                ) : (
                                    <form action="" className="w-full">
                                        <div className="grid grid-cols-1 gap-4 w-full">
                                            {companyFields.map((field) => (
                                                <div key={field.name} className="w-full">
                                                    <label className="block text-black">{field.label}:</label>
                                                    <input
                                                        type={field.type}
                                                        name={field.name}
                                                        value={companyFormData[field.name]}
                                                        onChange={handleCompanyChange}
                                                        required={field.required}
                                                        className="w-full px-3 py-2 border rounded-md"
                                                    />
                                                </div>
                                            ))}
                                            <div key={'sessionTime'}>
                                                <label>Session Time:</label>
                                                <select
                                                    name="sessionTime"
                                                    value={companyFormData.sessionTime}
                                                    onChange={handleCompanyChange}
                                                    className="w-full px-3 py-2 border rounded-md"
                                                >
                                                    <option value="" disabled>
                                                        Select Session Time
                                                    </option>
                                                    <option value="0">Dont keep me logged in</option>
                                                    <option value="15">15 min</option>
                                                    <option value="30">30 min</option>
                                                    <option value="45">45 min</option>
                                                </select>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>

                            <div className="flex justify-center mt-auto mb-4">
                                <button className="w-1/4 py-2 mx-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400" onClick={(e) => handleSubmit(e)}>Save</button>
                            </div>
                        </>)
                    }
                </div>

            </div>

        </div >

    );

}
export default Profile;